import { __assign } from "tslib";
import React from 'react';
import FullscreenDesktopNavbar from './fullscreenDesktopNavbar.js';
import FullscreenSidebar from './fullscreenSidebar.js';
import { Consts } from '@wix/photography-client-lib';
import ProGallerySlider from './ProGallerySlider';
import { fullscreenRenderer, sidebarRenderer, renderSlider, } from './expandUtils';
import { getBaseStyles } from './proGallerySliderFixedStyles';
import { GALLERY_v4_CONSTS } from '@wix/photography-client-lib';
function DesktopExpand(props) {
    var getDesktopNavbar = function () {
        return React.createElement(FullscreenDesktopNavbar, __assign({}, props));
    };
    var composeFullscreen = function () {
        var isFullscreen = props.isFullscreen, styles = props.styles, initialArrowsFocus = props.initialArrowsFocus, refocusArrows = props.refocusArrows;
        var aditionalStyles = isFullscreen
            ? {
                slideAnimation: GALLERY_v4_CONSTS.slideAnimations.FADE,
                arrowsPosition: GALLERY_v4_CONSTS.arrowsPosition.ON_GALLERY,
                arrowsSize: 80,
                itemClick: styles.allowFullscreenMagnifyImage
                    ? GALLERY_v4_CONSTS.itemClick.MAGNIFY
                    : GALLERY_v4_CONSTS.itemClick.NOTHING,
                magnificationLevel: styles.fullscreenMagnificationLevel,
            }
            : {
                slideAnimation: GALLERY_v4_CONSTS.slideAnimations.FADE,
                arrowsPosition: GALLERY_v4_CONSTS.arrowsPosition.OUTSIDE_GALLERY,
                arrowsSize: 50,
                itemClick: styles.allowFullscreenMagnifyImage
                    ? GALLERY_v4_CONSTS.itemClick.MAGNIFY
                    : GALLERY_v4_CONSTS.itemClick.NOTHING,
                magnificationLevel: styles.fullscreenMagnificationLevel,
            };
        var slider = renderSlider({
            props: props,
            aditionalStyles: aditionalStyles,
            container: getProGalleryContainer(),
            containerPostProcess: getContainerPostProcess(),
            isTouchDeviceZoom: false,
            classNames: isFullscreen
                ? 'pro-gallery-desktop-fullscreen'
                : 'pro-gallery-desktop-expand',
        });
        return [
            getDesktopNavbar(),
            slider,
            !isFullscreen && sidebarRenderer(props),
        ];
    };
    var getContainerPostProcess = function () {
        var _a;
        var currentWindow = props.currentWindow, isFullscreen = props.isFullscreen;
        var postProcess = {};
        if (props.shouldShowInfo) {
            if (props.styles.expandInfoPosition === Consts.expandInfoPositions.BOTTOM) {
                postProcess = {
                    height: {
                        percentage: 0.8,
                    },
                };
            }
            //info on side
            else {
                postProcess = {
                    width: {
                        percentage: 0.7,
                    },
                    height: {
                        addition: -Consts.desktopNavbarContainer.DESKTOP_NAVBAR_CONTAINER,
                    }
                };
            }
        }
        //no info
        else if (!isFullscreen) {
            postProcess = {
                height: {
                    addition: -Consts.desktopNavbarContainer.DESKTOP_NAVBAR_CONTAINER,
                }
            };
        }
        return __assign(__assign({}, postProcess), { height: __assign(__assign({}, ((postProcess === null || postProcess === void 0 ? void 0 : postProcess.height) || {})), { addition: (((_a = postProcess === null || postProcess === void 0 ? void 0 : postProcess.height) === null || _a === void 0 ? void 0 : _a.addition) || 0) + (isFullscreen ? 0 : -Consts.desktopNavbarContainer.DESKTOP_NAVBAR_CONTAINER) }) });
    };
    var getProGalleryContainer = function () {
        var currentWindow = props.currentWindow;
        var dim = currentWindow.size;
        var _a = getContainerPostProcess(), widthPostProcess = _a.width, heightPostProcess = _a.height;
        if (widthPostProcess || heightPostProcess) {
            dim = __assign(__assign({}, dim), { width: dim.width * ((widthPostProcess === null || widthPostProcess === void 0 ? void 0 : widthPostProcess.percentage) || 1) + ((widthPostProcess === null || widthPostProcess === void 0 ? void 0 : widthPostProcess.addition) || 0), height: dim.height * ((heightPostProcess === null || heightPostProcess === void 0 ? void 0 : heightPostProcess.percentage) || 1) + ((heightPostProcess === null || heightPostProcess === void 0 ? void 0 : heightPostProcess.addition) || 0) });
        }
        return dim;
    };
    var setRef = props.setRef, fullscreenClasses = props.fullscreenClasses;
    var fullscreenStyle = props.styles.expandInfoPosition === Consts.expandInfoPositions.BOTTOM
        ? { overflowY: 'visible', overflowX: 'hidden' }
        : {};
    return fullscreenRenderer({
        setRef: setRef,
        fullscreenClasses: fullscreenClasses,
        comp: composeFullscreen(),
        style: fullscreenStyle,
    });
}
export default DesktopExpand;
//# sourceMappingURL=DesktopExpand.js.map